import { useEffect, useState } from 'react';
import H5Com from '../../components/H5Com';
import IconQuiet from '../../components/IconQuiet';
import PCCom from './PCCom';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const TheComp: React.FC<{
    hasBottomGap?: boolean;
}> = ({ hasBottomGap = true }) => {
    const { t } = useLang('dp3.teaser.QuietComfort');
    const { locale } = getLocal();
    const [isPC, setIsPC] = useState(true);
    const IS_EAST_ASIA = ['cn', 'jp'].includes(locale);

    const imgArr = [
        {
            img: IS_EAST_ASIA
                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718870818707/c1%20(1).jpg'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886739486/a1%20(1).jpg',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718264886351/c1%20(1).jpg',
            title: t('img2_title'),
            desc: t('img2_desc'),
        },
    ];

    if (IS_EAST_ASIA) {
        imgArr.pop();
    }

    useEffect(() => {
        setIsPC(window.innerWidth > 1024);
    }, []);

    return (
        <div id="dp3-teaser-G" className={`${css['theComp']} dp3-module-box dp3-teaser-G`}>
            {isPC ? (
                <PCCom title={t('title')} imgArr={imgArr} subtitle={t('lMsg')} desc={t('rMsg')} tips={t('tips')} titleSvg={<IconQuiet />} hasTitleSvg={true} />
            ) : (
                <H5Com
                    title={t('title')}
                    imgArr={[
                        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717397118162/quiet_h5.png',
                        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718265605413/c4.jpg',
                    ]}
                    imgArrInfo={[
                        null,
                        {
                            title: t('img2_title'),
                            desc: t('img2_desc'),
                            titleSvg: <IconQuiet />,
                            hasTitleSvg: true,
                        },
                    ]}
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                    tips={t('tips')}
                    cls="dp3-teaser-G"
                />
            )}
            {hasBottomGap && <div className="dp3-spec"></div>}
        </div>
    );
};

export default TheComp;
